module.exports = __webpack_public_path__ + "img/22.93852557.png";